import { useEffect, type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { type Servicepoint, useFetchMultipleServicepoints } from '@dhl/receiver-servicepoint'
import { getCountryCodeFromHostname } from '@dhl/utils'

import { useGetProfileLastAddedAddress } from '~/profile/model/profile/hooks.js'
import { useSetTitle, useWizardContext } from '~/setup/model/context.js'
import { useGetDeliveryPreferenceForAddress } from '~/profile/view/preferences/hooks/useGetDeliveryPreferenceForAddress.js'
import { ServicepointSelect } from '~/profile/view/preferences/setup/components/ServicepointSelect.js'
import { steps } from '~/setup/model/steps.js'

export const DeliveryPreferenceServicePointList: FC = () => {
  const { t } = useTranslation()
  const { nextStep, setCurrentStepCanContinue, setStepSubmittedValues } = useWizardContext()
  const { data: lastAddedAddress } = useGetProfileLastAddedAddress()

  const { data: preferenceData } = useGetDeliveryPreferenceForAddress(lastAddedAddress?.addressId)

  const preference = preferenceData?.preference

  const { data: servicepoints, isLoading } = useFetchMultipleServicepoints({
    countryCode: preference?.address.countryCode ?? getCountryCodeFromHostname(),
    postalCode: preference?.address.postalCode!,
    servicePointIds: preference?.availableOptions?.availableServicePointIds ?? [],
  })

  useSetTitle(t('portal.profile.preferences.options.ServicePointDelivery.title'))

  const handleServicepointClick = (servicepoint: Servicepoint) => {
    setStepSubmittedValues(steps.deliveryPreferenceServicePointList, {
      addressId: lastAddedAddress?.addressId,
      servicepoint,
    })
    nextStep()
  }

  useEffect(() => {
    setCurrentStepCanContinue(false)
  }, [setCurrentStepCanContinue])

  return (
    <ServicepointSelect
      isLoading={isLoading}
      servicepoints={servicepoints ?? []}
      onServicepointClick={handleServicepointClick}
    />
  )
}
